import Checkbox from '@components/Checkbox';
import Chip from '@components/Chip';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import useTestUser from '@hooks/test/useTestUser';
import { useState } from 'react';

import methodList from './constants/methodList';
import MethodItem from './MethodItem';
import MoreIcon from './MoreIcon';
import SimplePayIcon from './SimplePayIcon';
import styles from './styles.module.scss';

function PaymentMethod() {
  const [isSimple, setIsSimple] = useState(false);
  const [expand, setExpand] = useState(false);
  const [remember, setRemember] = useState<boolean>(false);
  const isTestUser = useTestUser();
  return (
        <Column as='section'
                className={styles.container}
                fullWidth>
            <Text size='lg' fontWeight='bold'>결제 수단</Text>
            <Chip.Container variant='fill' className={styles.type}>
                <Chip isSelected={!isSimple} onClick={() => setIsSimple(false)}>일반결제</Chip>
                {/* <Chip isSelected={isSimple} onClick={() => setIsSimple(true)}>간편결제</Chip> */}
            </Chip.Container>
            {isSimple ? (
                <SimplePayIcon/>
            ) : (
                <Column fullWidth
                        align='center'
                        className={styles.gridContainer}>
                    <div className={`${styles.gridWrapper} ${expand && styles.expand}`}>
                        {isTestUser ? (
                            <article className={styles.grid}>
                                {methodList.map((data) => (
                                    <MethodItem {...data}
                                                key={data.method} />
                                ))}
                            </article>
                        ) : (
                            <article className={styles.single}>
                                <MethodItem method='CREDIT_CARD' >
                                    신용카드
                                </MethodItem>
                            </article>
                        )}
                    </div>
                    {isTestUser && (
                        <Column align='center'
                                onClick={() => setExpand(!expand)}
                                spacing={4}>
                            <Text color={colors.gray5}>더 많은 결제 수단 보기</Text>
                            <MoreIcon className={`${styles.more} ${expand && styles.expand}`}/>
                        </Column>
                    )}
                </Column>
            )}
            {/*
            <div className={styles.remember}>
                <Checkbox isChecked={remember}
                          onClick={() => setRemember(!remember)} >
                    이 결제수단 다음에서 사용하기
                </Checkbox>
            </div>
            */}
        </Column>
  );
}

export default PaymentMethod;
